module.exports = __webpack_public_path__ + "static/img/管路吊杆.23b24215.jpeg";